import React, {useContext} from "react";
import {useSelector} from "react-redux";
import {Button, Icon} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {getResponsiveStyles} from "../../utils/lib";
import IconCustom from "../../../../../../../Utils/IconCustom/IconCustom";

const ButtonComponent = ({component}) => {
    const {styles: sourceStyles, properties: {label, icon, type, startIcon, endIcon}} = component;
    const {currentCustomResolution} = useContext(ScreenDesignerContextNew);
    const {userLanguage} = useSelector(state => state.app)
    const styles = getResponsiveStyles(sourceStyles, currentCustomResolution);
    const multiLanguageLabel = multiLanguageValue(label, userLanguage);
    const defaultBackgrounds = ['primary', 'secondary', 'default'];
    const isOldBackground = defaultBackgrounds.indexOf(styles.color) !== -1 && !styles.background;
    const isDefaultBackground = defaultBackgrounds.indexOf(styles.background) !== -1;
    return (
        type === 'iconButton' ? (
            <IconButton
                color={isDefaultBackground ? styles.background : isOldBackground ? styles.color : ''}
                style={{
                    width: '100%', height: '100%',
                    padding: styles.padding ? styles.padding : 3,
                    color: isDefaultBackground ? '' : styles.background
                }}
            >
                <Icon fontSize={"small"}>
                    {icon}
                </Icon>
            </IconButton>
        ) : (
            <Button
                size={"small"}
                color={isOldBackground ? styles.color : styles.background}
                variant={styles.variant}
                startIcon={
                    startIcon && <IconCustom iconType={startIcon.iconType}>
                        {startIcon.icon ? startIcon.icon : startIcon}</IconCustom>
                }
                endIcon={endIcon && <IconCustom iconType={endIcon.iconType}>
                    {endIcon.icon ? endIcon.icon : endIcon}
                </IconCustom>}
                style={{
                    width: '100%',
                    height: '100%',
                    minWidth: styles.width,
                    background: styles.variant === 'contained' ? isOldBackground ? '' : !isDefaultBackground ? styles.background : '' : '',
                    borderColor: styles.variant === 'outlined' ? isOldBackground ? '' : !isDefaultBackground ? styles.background : '' : '',
                    borderRadius: styles.borderRadius,
                    color: styles.color,
                    padding: styles.padding,
                    fontSize: styles.fontSize,
                    fontWeight: styles.fontWeight,
                    fontStyle: styles.fontStyle,
                    textDecoration: styles.textDecoration
                }}
            >
                {multiLanguageLabel}
            </Button>
        )
    )
};

export default ButtonComponent;